import { render } from "./AlumniHeader.vue?vue&type=template&id=84a1d856"
import script from "./AlumniHeader.vue?vue&type=script&lang=js"
export * from "./AlumniHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__